export const SEASON_LIST = ["23SS", "23FW", "24SS", "24FW", "25SS"];
